import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb, Container, Segment } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { getBreadcrumbs } from '@plone/volto/actions';
import { getBaseUrl, hasApiExpander } from '@plone/volto/helpers'; 

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  breadcrumbs: {
    id: 'Breadcrumbs',
    defaultMessage: 'Breadcrumbs',
  },
});

const BreadcrumbsComponent = ({ pathname }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.breadcrumbs.items, shallowEqual);
  const root = useSelector((state) => state.breadcrumbs.root);

  useEffect(() => {
    if (!hasApiExpander('breadcrumbs', getBaseUrl(pathname))) {
      dispatch(getBreadcrumbs(getBaseUrl(pathname)));
    }
  }, [dispatch, pathname]);

  return (
    <Segment
      as="nav"
      aria-label={intl.formatMessage(messages.breadcrumbs)}
      className="breadcrumbs d-print-none "      
      vertical
			basic
    >
      <Container>
        <Breadcrumb className="breadcrumbs innerHeader__breadcrumbs">
          <Link
            to={root || '/'}
            className=" " 
          >
					{intl.formatMessage(messages.home)}            
							</Link>
							{items.map((item, index, items) => [
								<Breadcrumb.Divider key={`divider-${item.url}`} />,
								index < items.length - 1 ? (
									<Link key={item.url} to={item.url} className=" ">
										{item.title}
									</Link>
								) : (
									<Breadcrumb.Section as="strong" key={item.url} active>
										{item.title}
									</Breadcrumb.Section>
								),
							])} 
        </Breadcrumb>
      </Container>
    </Segment>
  );
};

BreadcrumbsComponent.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default BreadcrumbsComponent;
